export default __webpack_public_path__ + "static/media/slab_negativ.b1e5fd67.svg";